import { useEffect, useState } from 'react';
import HeaderBroadcast from '../../react/features/HeaderBroadcast';
import { TestDriveModeContainer } from '../../react/features/TestDriveMode';
import Sidebar from './Sidebar';
import styles from './style.m.less';
import TopBar from './TopBar';

type Props = {
    children: React.ReactNode;
    setShowNavigation: (show: boolean) => void;
    showNavigation: boolean;
};

export default function AppShell({ children, setShowNavigation, showNavigation }: Props) {
    const showTestDriveMode = useShowTestDriveMode();

    return (
        <div className={styles.shell}>
            <div className={styles.container}>
                <TopBar setShowNavigation={setShowNavigation} showNavigation={showNavigation} />
                <Sidebar />
                <div className={styles.contentWrapper}>
                    <HeaderBroadcast className={styles.broadcast} />
                    <main className={styles.content}>{children}</main>
                    {showTestDriveMode && <TestDriveModeContainer />}
                </div>
            </div>
        </div>
    );
}

const useShowTestDriveMode = () => {
    const [showTestDriveMode, setShowTestDriveMode] = useState(true);

    useEffect(() => {
        const handleKeydownHideTestDrive = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key === 't') {
                setShowTestDriveMode(prev => !prev);
            }
        };

        document.addEventListener('keydown', handleKeydownHideTestDrive);

        return () => {
            document.removeEventListener('keydown', handleKeydownHideTestDrive);
        };
    }, []);

    return showTestDriveMode;
};
